import { render, staticRenderFns } from "./MyDetail.vue?vue&type=template&id=068a6b65"
import script from "./MyDetail.vue?vue&type=script&lang=js"
export * from "./MyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports